<div class="signup-container">
  <div class="signup-card">
    <div class="signup-header">
      <img src="assets/images/zeymo-logo.svg" alt="Zeymo" class="logo" />
      <h1>Create your account</h1>
      <p>Get started with Zeymo ERP</p>
    </div>

    <!-- Success state -->
    <div *ngIf="submitSuccess" class="success-message">
      <div class="success-icon">&#10003;</div>
      <h2>Check your email</h2>
      <p>We've sent a verification link to <strong>{{ signupForm.get('email')?.value }}</strong>.</p>
      <p>Click the link to verify your email and start setting up your account.</p>
    </div>

    <!-- Signup form -->
    <form *ngIf="!submitSuccess" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
      <!-- Email -->
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          (input)="onEmailChange()"
          placeholder="you@company.com"
          [class.input-error]="emailStatus === 'taken'"
          [class.input-success]="emailStatus === 'available'"
        />
        <span *ngIf="emailStatus === 'checking'" class="field-hint">Checking availability...</span>
        <span *ngIf="emailStatus === 'available'" class="field-success">Email is available</span>
        <span *ngIf="emailStatus === 'taken'" class="field-error">{{ emailMessage }}</span>
      </div>

      <!-- Company Name -->
      <div class="form-group">
        <label for="companyName">Company Name</label>
        <input
          id="companyName"
          type="text"
          formControlName="companyName"
          (blur)="onCompanyNameBlur()"
          placeholder="Your Company Inc."
        />
      </div>

      <!-- Company Slug -->
      <div class="form-group">
        <label for="companySlug">Company Slug</label>
        <div class="slug-input-wrapper">
          <input
            id="companySlug"
            type="text"
            formControlName="companySlug"
            (input)="onSlugChange()"
            placeholder="yourcompany"
            [class.input-error]="slugStatus === 'taken'"
            [class.input-success]="slugStatus === 'available'"
          />
        </div>
        <span class="slug-preview" *ngIf="signupForm.get('companySlug')?.value">
          Your workspace: <strong>{{ signupForm.get('companySlug')?.value }}</strong>
        </span>
        <span *ngIf="slugStatus === 'checking'" class="field-hint">Checking availability...</span>
        <span *ngIf="slugStatus === 'available'" class="field-success">Slug is available</span>
        <span *ngIf="slugStatus === 'taken'" class="field-error">{{ slugMessage }}</span>
        <span *ngIf="signupForm.get('companySlug')?.hasError('pattern') && signupForm.get('companySlug')?.touched" class="field-error">
          Only lowercase letters and numbers allowed
        </span>
      </div>

      <!-- First Name / Last Name -->
      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First Name</label>
          <input id="firstName" type="text" formControlName="firstName" placeholder="John" />
        </div>
        <div class="form-group">
          <label for="lastName">Last Name</label>
          <input id="lastName" type="text" formControlName="lastName" placeholder="Doe" />
        </div>
      </div>

      <!-- Plan Selection -->
      <div class="form-group" *ngIf="plans.length > 0">
        <label>Select a Plan</label>
        <div class="plans-grid">
          <div
            *ngFor="let plan of plans"
            class="plan-card"
            [class.selected]="signupForm.get('planSlug')?.value === plan.slug"
            (click)="signupForm.patchValue({ planSlug: plan.slug })"
          >
            <div class="plan-name">{{ plan.name }}</div>
            <div class="plan-price">{{ plan.currency }} {{ plan.monthlyPricePerUser }}/user/mo</div>
            <div class="plan-desc" *ngIf="plan.description">{{ plan.description }}</div>
            <div class="plan-trial" *ngIf="plan.trialDays > 0">{{ plan.trialDays }}-day free trial</div>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <div *ngIf="submitError" class="submit-error">{{ submitError }}</div>
      <button
        type="submit"
        class="submit-btn"
        [disabled]="signupForm.invalid || isSubmitting || emailStatus === 'taken' || slugStatus === 'taken'"
      >
        {{ isSubmitting ? 'Creating account...' : 'Create Account' }}
      </button>
    </form>
  </div>
</div>
